import React from "react";
import InstituteOverview from "./institute-overview/InstituteOverview";
import Footer from "../../../components/footer/Footer";
import Navbar from "../../../components/navbar/Navbar";
import FounderLeadership from "./founder-leadership/FounderLeadership";
import Milestones from "./milestone-section/Milestones";
import InfrastructureSection from "./infrastructure-section/InfrastructureSection";
import ValuesCommitment from "./values-commitment/ValuesCommitment";
import LiveChat from "../section-component/live-chat/LiveChat";
import SocialMediaPanel from "../../../components/common/social-media/SocialMediaPanel";

const AboutIndex = () => {
    return (
        <>
            
            <InstituteOverview />
            {/* <FounderLeadership /> */}
            {/* <Milestones /> */}
            {/* <InfrastructureSection /> */}
            {/* <ValuesCommitment /> */}

            
        </>
    );
};

export default AboutIndex;
